import { Unionize } from 'utilitys/helpers/TsGeneral';
import { StateCreator, create } from 'zustand';

import { IClustersListItem } from 'components/pages/DurationForecastPage/DurationForecastPage.type';

interface Props {
    selectedClusterId?: IClustersListItem | null;
    searchWord: string | undefined;
    isAutomatedClusteringOption: boolean;
    isClustersList: boolean;
    update: (value: Unionize<Omit<Props, 'update'>>) => void;
}

const state: StateCreator<Props> = (set) => ({
    selectedClusterId: null,
    searchWord: undefined,
    isAutomatedClusteringOption: true,
    isClustersList: true,
    update: (value) => set({ ...value }),
});

export const useClusterRCFAnalysisStore = create(state);
